import React, { Fragment, useState } from 'react';
import { useIntl } from 'react-intl';

import ExtendBtn from 'components/Shared/ExtendBtn/ExtendBtn';
import { colors } from 'styles/cp';

export interface FaqProps {
  question?: string;
  answer?: string;
  onQuestionOpen?: () => void;
}

export const Faq: React.FC<FaqProps> = ({ question, answer, onQuestionOpen }) => {
  const intl = useIntl();
  const [isAnswerOpen, setIsAnswerOpen] = useState(false);

  const handleRowClick = () => {
    const wasClosed = !isAnswerOpen;
    setIsAnswerOpen(!isAnswerOpen);

    if (wasClosed && onQuestionOpen) {
      onQuestionOpen();
    }
  };

  return (
    <Fragment>
      <div className="faq-container" onClick={handleRowClick}>
        <div className="question">{question}</div>
        <ExtendBtn
          opened={isAnswerOpen}
          handler={handleRowClick}
          ariaLabel={intl.formatMessage({
            id: isAnswerOpen ? 'FAQ_HIDE_ANSWER' : 'FAQ_SHOW_ANSWER',
            defaultMessage: isAnswerOpen ? 'Hide answer' : 'Show answer',
          })}
        />
      </div>
      <div className="answer-container" data-testid="answer-container">
        <div className="answer">{answer}</div>
      </div>
      <style jsx>{`
        .faq-container {
          padding: 10px 18px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          cursor: pointer;
          .question {
            font-family: AvenirNextforINTUIT-Medium;
            padding: 8px 0 0 0;
            flex-grow: 1;
          }
        }
        .answer-container {
          padding: 0 18px;
          max-height: ${isAnswerOpen ? '250px' : 0};
          transition: all 0.35s ease-in-out;
          overflow: hidden;
          :global(svg) {
            transition: all 0.15s linear;
          }
          :global(.answer) {
            padding-bottom: 10px;
            display: flex;
            color: ${colors.gray01};
            font-size: 14px;
          }
        }
        :global(.question-text) {
          font-size: 14px;
          font-family: AvenirNextforINTUIT-Regular;
        }
        :global(.answer-text) {
          text-decoration: none;
          bold: off;
        }
      `}</style>
    </Fragment>
  );
};
